import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import ErrorBoundary from "@/components/ErrorBoundary";
import { EmailVerificationBanner } from "@/components/EmailVerificationBanner";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import LabDashboard from "@/pages/LabDashboard";
import CreateCase from "@/pages/CreateCase";
import CaseDetail from "@/pages/CaseDetail";
import DesignerDashboard from "@/pages/DesignerDashboard";
import Marketplace from "@/pages/Marketplace";
import DesignerProfileEdit from "@/pages/DesignerProfileEdit";
import LabAccount from "@/pages/LabAccount";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminPayouts from "@/pages/AdminPayouts";
import AdminDashboard from "@/pages/AdminDashboard";
import Why from "@/pages/Why";
import Receipt from "@/pages/Receipt";
import PayoutStatement from "@/pages/PayoutStatement";

function Shell() {
  const location = useLocation();
  const hideNav = location.pathname === "/auth";
  return (
    <>
      {!hideNav && <Navbar />}
      {!hideNav && <EmailVerificationBanner />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/why" element={<Why />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/lab" element={<ProtectedRoute role="lab"><LabDashboard /></ProtectedRoute>} />
        <Route path="/lab/new" element={<ProtectedRoute role="lab"><CreateCase /></ProtectedRoute>} />
        <Route path="/lab/edit/:id" element={<ProtectedRoute role="lab"><CreateCase /></ProtectedRoute>} />
        <Route path="/lab/account" element={<ProtectedRoute role="lab"><LabAccount /></ProtectedRoute>} />
        <Route path="/designer" element={<ProtectedRoute role="designer"><DesignerDashboard /></ProtectedRoute>} />
        <Route path="/designer/profile" element={<ProtectedRoute role="designer"><DesignerProfileEdit /></ProtectedRoute>} />
        <Route path="/marketplace" element={<ProtectedRoute><Marketplace /></ProtectedRoute>} />
        <Route path="/cases/:id" element={<ProtectedRoute><CaseDetail /></ProtectedRoute>} />
        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
        <Route path="/receipt/:sessionId" element={<ProtectedRoute><Receipt /></ProtectedRoute>} />
        <Route path="/payout/:sessionId" element={<ProtectedRoute><PayoutStatement /></ProtectedRoute>} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ErrorBoundary>
          <Shell />
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
